
exports.install = function (Vue, options) {
  // Vue.prototype.test = function () {
  //   console.log('test');
  // };
  Vue.prototype.shareToSinaWeiBo = function (title, url, pic) {
    var param = {
      url: url || 'www.baidu.com',
      /*分享地址(可选)*/
      type: '3',
      count: '1',
      /** 是否显示分享数，1显示(可选)*/
      appkey: '',
      /** 您申请的应用appkey,显示分享来源(可选)*/
      title: title,
      /** 分享的文字内容(可选，默认为所在页面的title)*/
      pic: pic || '',
      /**分享图片的路径(可选)*/
      ralateUid: '',
      /**关联用户的UID，分享微博会@该用户(可选)*/
      rnd: new Date().valueOf(),
    };
    var temp = [];
    for (var p in param) {
      temp.push(p + '=' + encodeURIComponent(param[p] || ''));
    }
    var targetUrl =
      'http://service.weibo.com/share/share.php?' + temp.join('&');
    window.open(targetUrl, 'sinaweibo', 'height=800, width=800');
  };
};